import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import SectionHeader from "@/components/feature/SectionHeader";
import MediaCard from "@/components/feature/MediaCard";
import NewsCard from "@/components/feature/NewsCard";
import { getFeaturedList, getMovieList, getTvList } from "@/utils/media";
import { getLatestNews } from "@/utils/news";

export default function Home() {
  const featured = getFeaturedList();
  const movies = [...getMovieList()]
    .sort((a, b) => (a.releaseDate < b.releaseDate ? 1 : -1))
    .slice(0, 8);
  const shows = [...getTvList()].sort((a, b) => b.hot - a.hot).slice(0, 8);
  const news = getLatestNews(5);

  return (
    <div className="w-full">
      <HeroCarousel items={featured} />

      <section className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <SectionHeader
          title="内容分类"
          subtitle="按你此刻的心情，快速进入电影、电视剧与影视资讯"
        />
        <CategoryEntries />
      </section>

      <section className="bg-background-100">
        <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
          <SectionHeader
            title="最新电影推荐"
            subtitle="近期上线与备受期待的电影作品，类型丰富不踩雷"
            moreTo="/category/movie"
          />
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 md:gap-5">
            {movies.map((item, index) => (
              <MediaCard key={item.id} item={item} index={index} />
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <SectionHeader
          title="热门电视剧推荐"
          subtitle="口碑与热度兼备，追剧清单一次备齐"
          moreTo="/category/tv"
        />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 md:gap-5">
          {shows.map((item, index) => (
            <MediaCard key={item.id} item={item} index={index} />
          ))}
        </div>
      </section>

      <section className="bg-background-100">
        <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
          <SectionHeader
            title="影视资讯精选"
            subtitle="行业动态、定档消息与市场观察，紧跟影视风向"
            moreTo="/category/news"
          />
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
            <NewsCard item={news[0]} />
            <div className="flex flex-col gap-4">
              {news.slice(1, 5).map((item) => (
                <NewsCard key={item.id} item={item} compact />
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}